import { motion } from "framer-motion";

const HeroGlow = () => {
  // Generate stable particle positions (seeded by index)
  const particles = [...Array(20)].map((_, i) => ({
    size: 8 + (i * 3) % 12,
    left: 15 + ((i * 17) % 70),
    top: 20 + ((i * 23) % 60),
    colorType: i % 3,
    duration: 4 + (i % 4),
    delay: (i * 0.3) % 3,
    yMove: -50 - (i % 5) * 20,
    xMove: ((i % 2) ? 1 : -1) * (30 + (i % 4) * 15),
  }));

  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
      {/* Main central glow - much larger */}
      <motion.div
        className="absolute w-[800px] h-[800px] md:w-[1200px] md:h-[1200px] rounded-full"
        style={{
          background: 'radial-gradient(circle, rgba(255,77,184,0.35) 0%, rgba(255,77,184,0.15) 30%, rgba(255,77,184,0.05) 50%, transparent 70%)',
        }}
        animate={{
          scale: [1, 1.15, 1],
          opacity: [0.6, 0.85, 0.6],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      {/* Secondary purple glow */}
      <motion.div
        className="absolute w-[600px] h-[600px] md:w-[900px] md:h-[900px] rounded-full"
        style={{
          background: 'radial-gradient(circle, rgba(168,85,247,0.3) 0%, rgba(168,85,247,0.1) 40%, transparent 70%)',
        }}
        animate={{
          scale: [1.1, 0.95, 1.1],
          opacity: [0.5, 0.7, 0.5],
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      {/* Third yellow/gold accent glow */}
      <motion.div
        className="absolute w-[400px] h-[400px] md:w-[700px] md:h-[700px] rounded-full"
        style={{
          background: 'radial-gradient(circle, rgba(250,204,21,0.2) 0%, rgba(250,204,21,0.08) 40%, transparent 60%)',
        }}
        animate={{
          scale: [0.9, 1.1, 0.9],
          opacity: [0.4, 0.6, 0.4],
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1,
        }}
      />

      {/* Floating particles - more and larger */}
      {particles.map((p, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full"
          style={{
            width: p.size + 'px',
            height: p.size + 'px',
            background: p.colorType === 0
              ? 'rgba(255,77,184,0.7)'
              : p.colorType === 1
              ? 'rgba(250,204,21,0.7)'
              : 'rgba(168,85,247,0.7)',
            boxShadow: p.colorType === 0
              ? '0 0 20px rgba(255,77,184,0.5), 0 0 40px rgba(255,77,184,0.3)'
              : p.colorType === 1
              ? '0 0 20px rgba(250,204,21,0.5), 0 0 40px rgba(250,204,21,0.3)'
              : '0 0 20px rgba(168,85,247,0.5), 0 0 40px rgba(168,85,247,0.3)',
            left: `${p.left}%`,
            top: `${p.top}%`,
          }}
          animate={{
            y: [0, p.yMove, 0],
            x: [0, p.xMove, 0],
            opacity: [0.4, 0.9, 0.4],
            scale: [1, 1.3, 1],
          }}
          transition={{
            duration: p.duration,
            repeat: Infinity,
            ease: "easeInOut",
            delay: p.delay,
          }}
        />
      ))}

      {/* Soft rotating light rays - larger */}
      <motion.div
        className="absolute w-[900px] h-[500px] md:w-[1400px] md:h-[700px]"
        style={{
          background: 'conic-gradient(from 0deg, transparent, rgba(255,77,184,0.1), transparent, rgba(250,204,21,0.1), transparent, rgba(168,85,247,0.08), transparent)',
          filter: 'blur(60px)',
        }}
        animate={{
          rotate: [0, 360],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "linear",
        }}
      />
    </div>
  );
};

export default HeroGlow;
